import Polygon from './Polygon';

import './Balloon.scss';

interface IProps extends React.ComponentPropsWithoutRef<'div'> {
  title: string;
  count: number;
}

export default function Balloon({title, count, className, ...restProps}: IProps) {
  return (
    <div className={`admin-page__balloon ${className}`} {...restProps}>
      <span className="admin-page__balloon-count">{count}</span>
      <span className="admin-page__balloon-title">{title}</span>
      <Polygon />
    </div>
  );
}
